const inaCheckResponseTypes = {
    INA_CHECK_PASSED: 'INA_CHECK_PASSED',
    INA_CHECK_FAILED: 'INA_CHECK_FAILED',
    INA_API_FAILED: 'INA_API_FAILED',
};

export default inaCheckResponseTypes;
